<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
// Card "Solicitação Lais Visita" do "Histórico de cliente".
// Extraído de HistoricoCliente.vue: mesma copy, mesmos estados (dados, erro e vazio).
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisInfoRow from 'dashboard/components-next/LaisInfoRow.vue';
import LeadHistoryState from './LeadHistoryState.vue';
import {
  formatDateTime,
  formatVisitWindow,
  toDate,
} from '../utils/leadHistoryPresenter';

const props = defineProps({
  publicVisitRequest: { type: Object, default: null },
  visitasLoadError: { type: Boolean, default: false },
  visitasErrorCopy: {
    type: Object,
    default: () => ({ title: '', description: '' }),
  },
});

defineEmits(['saberMais', 'retry']);

const publicVisitHour = computed(() => {
  const request = props.publicVisitRequest || {};
  const scheduledAt = toDate(request.scheduled_at);
  if (scheduledAt) {
    return scheduledAt.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  const preferredTime = String(request.preferred_time || '').trim();
  if (preferredTime) return preferredTime;

  return formatVisitWindow(request.requested_window);
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard>
    <template #header>
      <h2
        class="text-[16px] font-semibold leading-tight text-lais-text font-redHatDisplay"
      >
        Solicitação Lais Visita
      </h2>
    </template>
    <template #titleAction>
      <button
        type="button"
        class="text-[12px] font-semibold text-lais-primary hover:text-[#3d2966] underline decoration-lais-warning decoration-[1.5px] underline-offset-[3px]"
        @click="$emit('saberMais')"
      >
        Saber mais
      </button>
    </template>
    <div v-if="publicVisitRequest" class="grid gap-3 py-2">
      <LaisInfoRow icon="i-lucide-calendar-plus" label="Solicitada em">
        {{ formatDateTime(publicVisitRequest.requested_at) }}
      </LaisInfoRow>
      <LaisInfoRow icon="i-lucide-calendar-days" label="Datas sugeridas">
        {{ formatVisitWindow(publicVisitRequest.requested_window) }}
      </LaisInfoRow>
      <LaisInfoRow icon="i-lucide-clock-3" label="Horário">
        {{ publicVisitHour }}
      </LaisInfoRow>
      <LaisInfoRow icon="i-lucide-home" label="Imóvel">
        {{
          publicVisitRequest.imovel_id
            ? `Imóvel #${publicVisitRequest.imovel_id}`
            : 'Imóvel não informado'
        }}
      </LaisInfoRow>
    </div>
    <LeadHistoryState
      v-else-if="visitasLoadError"
      container-class="py-5 text-center"
      :title="visitasErrorCopy.title"
      :description="visitasErrorCopy.description"
      action-label="Tentar novamente"
      @action="$emit('retry')"
    />
    <div v-else class="flex flex-col items-center text-center py-4">
      <div
        class="size-32 rounded-lais bg-lais-bg-soft grid place-items-center mb-4"
      >
        <span
          class="i-lucide-calendar-days text-lais-primary size-12"
          aria-hidden="true"
        />
      </div>
      <p
        class="text-[14px] font-semibold text-lais-text max-w-[280px] leading-relaxed"
      >
        Não houve nenhuma visita solicitada via Lais Visita.
      </p>
      <p
        class="mt-2 text-[13px] text-lais-text-body max-w-[280px] leading-relaxed"
      >
        Permita que seus clientes solicitem visitas no pré atendimento da Lais.
      </p>
    </div>
  </LaisCard>
</template>
